import React, { ReactElement } from "react";
import "./index.less";
interface Props {
  children: ReactElement | ReactElement[];
}
export default function (props: Props) {
  return (
    <div className="joyspace-maintabs">
      <ul>
        {React.Children.map(props.children, (el) => (
          <li>{el}</li>
        ))}
      </ul>
    </div>
  );
}
